import { call, spawn, take } from "redux-saga/effects";
import * as PersistenceEngine from "../persistence/engine";
import { shouldPersistAction } from "../persistence/whitelist";

function* save(state: any) {
  try {
    yield call(PersistenceEngine.save, state);
  } catch (e) {
    yield call(
      console.info,
      "An error occurred trying to persist action(s)",
      e
    );
  }
}

export default function* persistenceSaga() {
  while (true) {
    // Take any redux action
    const action: { type: string } = yield take();

    // Check if the action should be persisted (if it's in the whitelist)
    if (!shouldPersistAction(action.type)) {
      continue;
    }

    // Load the persisted actions
    let savedStates: { [key: string]: any } = yield call(
      PersistenceEngine.load
    );

    // Set the action with the key "action.type" to the taken action
    savedStates[action.type] = action;

    // Save the action to local storage
    yield spawn(save, savedStates);
  }
}
